export enum PointingCheckpoint {
	Register = 1,
	Login = 2,
	CheckOut = 3,
	AddingReviews = 4,
	ShareLink = 5,
	ReviewSalon = 6,
}
export enum CheckOutModuleEnum {
	General = 1,
	MarketPlace = 2,
	Salons = 3,
}
export enum PointingSystemTabs {
	ALL = 1,
	PENDING = 2,
	EARNED = 3,
	DEDUCTED = 4,
}
export enum PointsStatusEnum {
	Earned = 1,
	Deducted = 2,
	Pending_Earned = 3,
	Pending_Deducted = 4,
}
